import React, { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route, useLocation, Redirect } from 'react-router-dom';

import useCurrentLanguage from 'utils/hooks/useCurrentLanguage';
import useUserRoles from 'utils/hooks/auth/useUserRoles';

import Landing from 'views/Landing';
import Submissions from 'views/Submissions';
import SubmissionDetail from 'views/SubmissionDetail';
import Users from 'views/Users';
import BlackBoxSubmission from 'views/BlackboxSubmission';
import useUserHasFullAuth from '../../utils/hooks/auth/useUserHasFullAuth';

export default () => {
  const location = useLocation();
  const isAuthenticated = useUserHasFullAuth();
  const { isMainUser, isReporter, isBlackBoxUploader } = useUserRoles();
  const language = useCurrentLanguage();
  const { institutions, institutionsLoading } = useSelector(state => state.institutions);

  const hasInstitutions = institutions.length > 0;

  useLayoutEffect(() => {
    window.scrollTo(0, 0);

    //this is set in IE for some reason, disables opening of selects & writing in RTE if not removed
    document.getElementById('root').removeAttribute('disabled');
  }, [location.pathname]);

  return (
      <Switch>
        <Redirect from="/" to={`/${language}`} exact />
        {isAuthenticated && !institutionsLoading && (
            <>
              {hasInstitutions ? (
                  <>
                    <Route exact path="/:lang" component={Submissions} />
                    <Route
                        exact
                        path="/:lang/submission/:submissionId"
                        component={SubmissionDetail}
                    />
                    <Route
                        exact
                        path="/:lang/:institutionId/submissions"
                        component={Submissions}
                    />
                    <Route
                        exact
                        path="/:lang/:institutionId/reporters"
                        component={Users}
                    />
                  </>
              ) : (
                  <Route exact path="/:lang" component={Landing} />
              )}

              {isBlackBoxUploader && !(isMainUser || isReporter) && (
                  <>
                    <Redirect from="/:lang" to={`/${language}/blackbox`} exact />
                    <Route
                        exact
                        path="/:lang/blackbox"
                        component={BlackBoxSubmission}
                    />
                  </>
              )}
            </>
        )}
      </Switch>
  );
};
